import LongNameFormatter from "@components/formatters/long-name-formatter";
import { getStatusBadge } from "@helpers/utils";
import { Badge } from "reactstrap";
import useDateHandler from "@hooks/use-date-handler";
import { DATE_FORMAT_VIEW } from "@constants/index";
import LoadingButton from "@components/ui-components/loading-button";

const getColumns = ({ handleRowActions }) => {
    const { dateFormatter } = useDateHandler();
    const columns = [
        {
            name    : "Name",
            selector: (row) => row.name,
            width   : "250px",
            cell    : (row) => {
                return (
                    <LongNameFormatter
                        content={row.name}
                        className="fw-bold"
                        id={`plan-${row._id}`}
                        max={100}/>
                );
            }
        },
        {
            name    : "Description",
            selector: (row) => row.desc || "-",
            width   : "350px",
            cell    : (row) => {
                return (
                    <LongNameFormatter
                        content={row.desc}
                        className="fw-bold"
                        id={`plan-desc-${row._id}`}
                        max={100}/>
                );
            }
        },
        {
            name    : "Status",
            selector: (row) => row.status,
            width   : "100px",
            cell    : (row) => {
                return (
                    <Badge color={getStatusBadge(row.status).color}>
                        {getStatusBadge(row.status).title}
                    </Badge>
                );
            }
        },
        {
            name    : "Created At",
            selector: (row) => row.created_at,
            width   : "200px",
            cell    : (row) => {
                return   dateFormatter({
                    date    : row?.created_at,
                    formatAs: DATE_FORMAT_VIEW
                });
            }
        },
        {
            name    : "Created By",
            selector: (row) => row.created_by.name,
            width   : "200px",
            cell    : (row) => {
                return  <LongNameFormatter
                    content={row.created_by.name}
                    className="fw-bold"
                    id={`plan-${row._id}`}
                    max={100}/>;
            }
        },
        {
            name: "Actions",
            cell: row => (
                <>
                    <LoadingButton
                        className="me-1"
                        outline
                        color="info"
                        testId={`${row._id}-edit-plan`}
                        subject="plans"
                        onClick={() => handleRowActions("edit", row)}
                        id={`${row._id}-edit-button`}
                        icon="pencil"/>
                    <LoadingButton
                        outline
                        testId={`${row._id}-delete-plan`}
                        onClick={() => handleRowActions("delete", row)}
                        color="danger"
                        subject="plans"
                        id={`${row._id}-edit-delete`}
                        icon="delete"/>
                </>
            )
        }
    ];

    return columns;
};

export default getColumns;
